exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__container___3_j56{justify-content:center;align-items:center;display:flex;margin:10px}.styles__icon___2Y5xA{fill:#0a6eb4}", ""]);

// Exports
exports.locals = {
	"container": "styles__container___3_j56",
	"icon": "styles__icon___2Y5xA"
};